// @ts-nocheck
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import styled from 'styled-components';

import PageLayout from '../../layout/PageLayout';

const PageTitle = styled(Typography)`
  padding-bottom: ${(props) => props.theme.spacing(2)}px;
`;

const SectionTitle = styled(Typography)`
  padding: ${(props) => props.theme.spacing(1, 0, 0.5, 0)};
`;

const StyledPaper = styled(Paper)`
  margin: ${(props) => props.theme.spacing(4)} auto;
`;

const HeaderCell = styled(TableCell)`
  background-color: ${(props) => props.theme.palette.grey[200]};
  font-weight: 600;
  padding: ${(props) => props.theme.spacing(1, 2)};
  border-bottom: 2px solid ${(props) => props.theme.palette.divider};
`;

const BodyCell = styled(TableCell)`
  padding: ${(props) => props.theme.spacing(1, 2)};
  border-top: 1px solid ${(props) => props.theme.palette.divider};
`;

function CookiePolicyDE() {
  return (
    <PageLayout>
      <PageTitle variant="h1" color="primary">
        Mer Germany – Cookie Policy GROA Kundenportal (groa.mer.eco)
      </PageTitle>

      <Typography variant="body1" align="center" paragraph>
        (Stand: November 2025)
      </Typography>

      <SectionTitle variant="h3">1. Einführung</SectionTitle>

      <Typography variant="body1" paragraph>
        Unser Online-Kundenportal <a href="https://groa.mer.eco">https://groa.mer.eco</a> (nachfolgend: “GROA” oder
        “Kundenportal”) verwendet Cookies und Technologien mit vergleichbarer Funktionsweise. Nachfolgend informieren
        wir, die Mer Germany GmbH (nachfolgend „Mer“, „uns“, „wir“), Sie über die Verwendung solcher Cookies und
        ähnlicher Technologien auf dem Kundenportal.
      </Typography>

      <SectionTitle variant="h3">2. Was sind Cookies und ähnliche Technologien?</SectionTitle>

      <Typography variant="body1" paragraph>
        Cookies sind Textdateien, die von einem Webserver auf Ihrem Endgerät abgelegt werden. Diese Cookies ermöglichen
        es, Informationen auf Ihrem Endgerät zu speichern und auf gespeicherte Informationen zuzugreifen.
      </Typography>
      <Typography variant="body1" paragraph>
        Unterscheiden lässt sich zum einen zwischen Cookies, die unmittelbar nach Beenden des Nutzungsvorgangs gelöscht
        werden (sog. „Session-Cookies“), und solchen Cookies, die auf Ihrem Endgerät für einen bestimmten Zeitraum
        verbleiben (sog. „persistente Cookies“).
      </Typography>
      <Typography variant="body1" paragraph>
        Weiter ist zwischen First Party Cookies und Third Party Cookies zu unterscheiden. First Party Cookies werden
        unmittelbar von uns verwaltet und ausgelesen. Demgegenüber haben Third Party Cookies die Besonderheit, dass
        diese von einem Drittanbieter gesteuert und verwaltet werden.
      </Typography>
      <Typography variant="body1" paragraph>
        Neben Cookies setzen wir auch vergleichbare Technologien ein, die ebenfalls Informationen in Ihrem Browser oder
        Gerät speichern und/oder auslesen und dabei lokal freigegebene Objekte oder lokalen Speicher nutzen. Hierzu
        gehören beispielsweise Web-Beacons bzw. Zähl-Pixel. Hierbei handelt es sich um ein elektronisches Grafikbild,
        das in eine Webseite eingebettet ist, um Informationen zu Ihrem Besuch auf einer Webseite zu erfassen (z.B. Art
        des genutzten Geräts und Browsers, IP-Adresse, Aufruf der Webseite, Anklicken von bestimmten Links oder
        Objekten).
      </Typography>
      <Typography variant="body1" paragraph>
        Mithilfe solcher Cookies und ähnlichen Technologien können Sie als Besucher des Kundenportal eindeutig
        zugeordnet werden. Dadurch ist es möglich, Sie beim nächsten Besuch unserer Webseite wiederzuerkennen.
      </Typography>
      <Typography variant="body1" paragraph>
        Nachfolgend verwenden wir den Begriff “Cookies” ganzheitlich im Hinblick auf Cookies und ähnliche Technologien.
      </Typography>

      <SectionTitle variant="h3">3. Welche Cookies verwenden wir?</SectionTitle>
      <SectionTitle variant="h3">3.1. Unbedingt erforderliche Cookies</SectionTitle>

      <Typography variant="body1" paragraph>
        Diese Cookies stellen sicher, dass bestimmte Services der Website, die für deren Nutzung unbedingt erforderlich
        sind, ordnungsgemäß funktionieren. Da der Einsatz dieser Cookies zwingend für die Nutzung der Website ist, sind
        diese Cookies unabhängig von einer Einwilligung stets aktiviert sind.
      </Typography>
      <Typography variant="body1" paragraph>
        Wir setzen aktuell die folgenden unbedingt erforderlichen Cookies ein:
      </Typography>
      <StyledPaper elevation={2}>
        <Table align="center">
          <TableHead>
            <TableRow>
              <HeaderCell>Cookie-Name</HeaderCell>
              <HeaderCell>Funktion</HeaderCell>
              <HeaderCell>Anbieter / Domäne</HeaderCell>
              <HeaderCell>Speicherdauer</HeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <BodyCell>cookieConsent</BodyCell>
              <BodyCell>
                Cookie zur Speicherung der Präferenz des Nutzers zwecks Bestätigung des Einsatzes von
                einwilligungs-bedürftigen Cookies
              </BodyCell>
              <BodyCell>Mer</BodyCell>
              <BodyCell>1 Jahr</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>_legacy_auth0.is.authenticated</BodyCell>
              <BodyCell>Authentifizierung</BodyCell>
              <BodyCell>Auth0</BodyCell>
              <BodyCell>7 Tage</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>auth0.is.authenticated</BodyCell>
              <BodyCell>Authentifizierung</BodyCell>
              <BodyCell>Auth0</BodyCell>
              <BodyCell>7 Tage</BodyCell>
            </TableRow>
          </TableBody>
        </Table>
      </StyledPaper>

      <SectionTitle variant="h3">3.2. Analyse Cookies</SectionTitle>

      <Typography variant="body1" paragraph>
        Diese Cookies helfen uns, Ihr Nutzungsverhalten auf unserer Website und Ihre persönlichen Präferenzen zu
        erfassen. Wir verwenden diese Informationen, um unsere Website auf Ihre Interessen ausrichten zu können. Der
        Einsatz dieser Cookies erfolgt nur mit Ihrer Einwilligung und kann jederzeit wieder deaktiviert werden.
      </Typography>
      <Typography variant="body1" paragraph>
        Wir setzen aktuell die folgenden Analyse Cookies ein:
      </Typography>
      <StyledPaper elevation={2}>
        <Table align="center">
          <TableHead>
            <TableRow>
              <HeaderCell>Cookie-Name</HeaderCell>
              <HeaderCell>Funktion</HeaderCell>
              <HeaderCell>Anbieter / Domäne</HeaderCell>
              <HeaderCell>Speicherdauer</HeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <BodyCell>_ga</BodyCell>
              <BodyCell>Daten zu erheben und Ihre Website-Nutzungsstatistiken</BodyCell>
              <BodyCell>Google Analytics</BodyCell>
              <BodyCell>2 Jahre</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>_gcl_au</BodyCell>
              <BodyCell>Daten zu erheben und Ihre Website-Nutzungsstatistiken</BodyCell>
              <BodyCell>Google Analytics</BodyCell>
              <BodyCell>90 Tage</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>_uetvid</BodyCell>
              <BodyCell>Daten zu erheben und Ihre Website-Nutzungsstatistiken</BodyCell>
              <BodyCell>Microsoft</BodyCell>
              <BodyCell>90 Tage</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>sbjs_current</BodyCell>
              <BodyCell>Daten zu erheben und Ihre Website-Nutzungsstatistiken</BodyCell>
              <BodyCell>Sourcebuster</BodyCell>
              <BodyCell>Dauer der Session</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>sbjs_current_add</BodyCell>
              <BodyCell>Daten zu erheben und Ihre Website-Nutzungsstatistiken</BodyCell>
              <BodyCell>Sourcebuster</BodyCell>
              <BodyCell>Dauer der Session</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>sbjs_first</BodyCell>
              <BodyCell>Daten zu erheben und Ihre Website-Nutzungsstatistiken</BodyCell>
              <BodyCell>Sourcebuster</BodyCell>
              <BodyCell>Dauer der Session</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>sbjs_first_add</BodyCell>
              <BodyCell>Daten zu erheben und Ihre Website-Nutzungsstatistiken</BodyCell>
              <BodyCell>Sourcebuster</BodyCell>
              <BodyCell>Dauer der Session</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>sbjs_migrations</BodyCell>
              <BodyCell>Daten zu erheben und Ihre Website-Nutzungsstatistiken</BodyCell>
              <BodyCell>Sourcebuster</BodyCell>
              <BodyCell>Dauer der Session</BodyCell>
            </TableRow>
            <TableRow>
              <BodyCell>sbjs_udata</BodyCell>
              <BodyCell>Daten zu erheben und Ihre Website-Nutzungsstatistiken</BodyCell>
              <BodyCell>Sourcebuster</BodyCell>
              <BodyCell>Dauer der Session</BodyCell>
            </TableRow>
          </TableBody>
        </Table>
      </StyledPaper>

      <SectionTitle variant="h3">4. Aktivierung/Deaktivierung und Löschen von Cookies</SectionTitle>

      <Typography variant="body1" paragraph>
        Sie können den Einsatz von Cookies in allen gängigen Browsern blockieren, im dem Sie entsprechende Einstellungen
        in Ihrem Browser vornehmen. Bereits gesetzte Cookies können Sie löschen. Nähere Informationen dazu können Sie
        unter der Hilfefunktion aller gängigen Browsers einsehen.
      </Typography>
      <Typography variant="body1" paragraph>
        Bitte beachten Sie, dass Sie über die Einstellungen in Ihrem Browser unter Umständen nicht sämtliche
        Technologien, die Informationen auf Ihrem Endgerät speichern oder auf dort gespeicherte Informationen zugreifen,
        blockieren können.
      </Typography>
      <Typography variant="body1" paragraph>
        Bitte beachten Sie, dass die Website möglicherweise nicht richtig funktioniert, wenn alle Cookies deaktiviert
        sind. Wenn Sie Cookies in Ihrem Browser löschen, werden diese neu platziert, wenn Sie unsere Website erneut
        besuchen.
      </Typography>

      <SectionTitle variant="h3">5. Kontaktdaten</SectionTitle>

      <Typography variant="body1" paragraph>
        Für Fragen und/oder Kommentare zu unserer Cookie Policy können Sie uns über die in Ziffer 1 unserer
        Datenschutzerklärung für das Kundenportal enthaltenen Kontaktdaten kontaktieren.
      </Typography>
    </PageLayout>
  );
}

export default CookiePolicyDE;
